import Markdown from "react-markdown";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import { cn } from "#app/utils/misc.tsx";

// Strict allowlist: only inline formatting, paragraphs, line breaks, and lists
const sanitizeSchema = {
	...defaultSchema,
	tagNames: ["p", "strong", "em", "br", "ul", "ol", "li"],
	attributes: {},
};

export function SafeMarkdown({
	content,
	className,
}: {
	content: string;
	className?: string;
}) {
	return (
		<div
			className={cn("safe-markdown", className)}
			style={{ fontFamily: "var(--serif)" }}
		>
			<Markdown rehypePlugins={[[rehypeSanitize, sanitizeSchema]]}>
				{content}
			</Markdown>
		</div>
	);
}
